import { withAdminAuth } from "../../../components/GetAuth";
import PageHeader from "../../../components/PageHeader";
import { CurrencyFormatter } from "../../../components/Helpers";
import { useWebsite } from "../../../../context/WebsiteContext";
import { useSiteBranding } from "../../../../hooks/useSiteBranding";
import styles from "../reports.module.css";
import useServerReport from "../components/useServerReport";
import ReportToolbar from "../components/ReportToolbar";
import ReportTable from "../components/ReportTable";
import ServiceFilter from "../components/ServiceFilter";
import { toFixed2, toNumber } from "../components/exportUtils";

const dueBalance = (row) => toNumber(row?.total_amount) - toNumber(row?.paid_amount);

const columns = [
    { key: "customer_id", label: "Customer Id" },
    { key: "name", label: "Customer Name", primary: true },
    { key: "total_booking", label: "Total Booking", align: "right" },
    { key: "total_amount", label: "Total Amount", align: "right", render: (row) => CurrencyFormatter(toNumber(row?.total_amount)), exportValue: (row) => toFixed2(row?.total_amount) },
    { key: "paid_amount", label: "Paid Amount", align: "right", render: (row) => CurrencyFormatter(toNumber(row?.paid_amount)), exportValue: (row) => toFixed2(row?.paid_amount) },
    { key: "due_balance", label: "Due Balance", align: "right", render: (row) => CurrencyFormatter(dueBalance(row)), exportValue: (row) => dueBalance(row).toFixed(2) },
];

const OrderReports = () => {
    const { websiteData } = useWebsite();
    useSiteBranding("Customer Orders", websiteData);

    const report = useServerReport("report/customer-orders", { service: "all" });

    return (<div className={`${styles.MainDiv}`}>
        <PageHeader title="Customer Orders" trail={[{ label: "Reports" }]} />

        <div className={`${styles.MainCard}`}>
            <ReportToolbar report={report} columns={columns} title="Customer Orders Report" filename="customer-orders-report" searchPlaceholder="Search by customer id or name">
                <ServiceFilter report={report} />
            </ReportToolbar>
            <ReportTable report={report} columns={columns} />
        </div>
    </div>);
};

export default withAdminAuth(OrderReports);
